import { statusColor } from '../data/format.js'

/**
 * Thin horizontal progress bar used inside goal and sub-goal cards.
 * Width scales with `pct`; color bands match the old dashboard's
 * green / amber / red thresholds.
 */
export default function ProgressBar({ pct, color }) {
  const safePct = Math.max(0, Math.min(100, pct || 0))
  const fill = color || statusColor(safePct)
  return (
    <div
      style={{
        height: 6,
        width: '100%',
        background: '#f3f4f6',
        borderRadius: 99,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${safePct}%`,
          background: fill,
          transition: 'width 0.4s ease',
        }}
      />
    </div>
  )
}
